<template>
  <div :class="['usb-sample']">
    <div id="three-up-section" class="usb-section">
      <div class="three-up-inner">
        <h1><span class="line">The Classic</span> <span class="line">USB Club USB.</span></h1>

        <div class="three-container">
          <div class="feature">
            <h3><span class="icon icon-home"><img class="chest-icon" src="/figures/icons/home.svg" /></span><div class="feature-title-padded">128 GB</div></h3>
            <h2>An empty home to furnish with you and your friend’s favorite files.</h2>
          </div>
          <div class="feature">
            <h3><span class="icon"><img class="usbc-icon" src="/figures/icons/double-arrow.svg" /></span><div class="feature-title-padded">Dual-Sided</div></h3>
            <h2>Plug-in to everything from your Grandma’s PC, to your Phone, to the CDJ.</h2>
          </div>
          <div class="feature">
            <h3><span class="icon"><img class="key-icon" src="/figures/icons/car-key.svg" /></span><div class="feature-title-padded">USB Club Key</div></h3>
            <h2>Each USB comes with an invite to the network.</h2>
          </div>
        </div>
      </div>
    </div>

    <div class="usb-section" id="on-the-network">
      <div class="on-the-network-text-section">
        <h3>On the network,</h3>
        <h1>Everyday's a potluck.</h1>
        <h2>Pair your USB with the Console to share and discover your favorite files.</h2>
        <h4>Via the <span><img src="/figures/icons/apple.svg" /></span> Mac Desktop App</h4>
      </div>
      <div class="on-the-network-img-section">
        <div class="static-console-img">
          <img src="/figures/console-today.png" />
        </div>
        <div class="carousel">
          <CarouselSample></CarouselSample>
        </div>
      </div>
    </div>
    <div class="usb-section" id="palm">
      <div class="palm-container">
        <div class="img-container">
          <img src="/figures/sample-palm.png" class="blur" />
          <img src="/figures/sample-palm.png" />
        </div>
        <div class="text-container">
          <h1>Fits in the palm<br>of your hand.</h1>
          <h2>
            So you never leave the house without <br> your &nbsp;<span><img src="/figures/icons/phone.svg" /></span>
            phone,&nbsp; <span><img src="/figures/icons/wallet.svg" /></span> wallet, and <span class="keys"><img
                src="/figures/icons/line.svg" />keys</span> <span><img src="/figures/icons/usb.svg" /></span> USB.
          </h2>
        </div>
      </div>
    </div>
    <div class="usb-section" id="best-of-both-worlds">
      <div class="text-container">
        <h3>Best of Both Worlds</h3>
        <h2>Swivel between USB-A and USB-C to enjoy files on projectors, printers, cars, and anything else you can think
          to plug-in to.</h2>
      </div>
      <div class="top-gradient gradient"></div>
      <div class="bottom-gradient gradient"></div>

    </div>
  </div>
  <div class="usb-section" id="join-the-club">
    <div class="sample-7-indent">
      <img src="/figures/classic-indent.png" />
    </div>
    <div class="text-container">
      <h2>Join the club.</h2>
      <div class="cta-container">
        <span class="detail-text detail-left">128 GB</span>
        <a href="https://buy.usb.club/products/sample-8" class="button cta-button"><span>Buy</span> $40 →</a>
        <span class="detail-text detail-right">Club Key</span>
      </div>
    </div>
    <div class="bottom-button">
      <a href="/transport" class="button cta-button"><span>or View Transport</span> →</a>
    </div>
    <div class="bottom-gradient gradient"></div>
  </div>
</template>

<script>

import CarouselSample from "./CarouselSample.vue"

export default {
  name: "USB_Sample",
  components: {
    CarouselSample
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
  head() {
    return {
      title: "Classic USB",
      meta: [
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:title",
          content: "Join Waitlist",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:description",
          content: "The Orignal USB Club USB",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:image",
          content: "https://usb.club/figures/og/ClassicUSBOG.png",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "description",
          content: "The Orignal USB Club USB",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "image",
          content: "https://usb.club/figures/og/ClassicUSBOG.png",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:description",
          content: "The Orignal USB Club USB",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:title",
          content: "Classic USB",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:image",
          content: "https://usb.club/figures/og/ClassicUSBOG.png",
        },
      ],
    };
  },
};
</script>

<style scoped>
span.line {
  display: inline-block;
}

h1 {
  font-size: 52px;
}

h3 {
  font-family: 'ISO', monospace;
  font-size: 20px;
  letter-spacing: normal;
  font-weight: 600;
  color: #F9F9F9;
}

h2 {
  font-family: 'Untitled Serif', serif;
  font-size: 26px;
  letter-spacing: -1px;
  font-weight: 400;
  max-width: 48rem;
}

h4 {
  font-family: 'Untitled Serif', serif;
  color: #a9a9a9;
  font-size: 16px;
  letter-spacing: -0.5px;
  font-weight: 400;
}

.gradient {
    width: 100%;
    height: 4rem;
    position: absolute;
    background: rgb(28, 28, 28);
  }

.chest-icon {
  transform: scale(1.2);
  position: relative;
  top: 0px;
  height: 20px;
}

.usbc-icon {
  position: relative;
  transform: scale(.8);
  top: 3px;
  height: 20px;
}

.key-icon {
  position: relative;
  transform: scale(.8);
  top: 2px;
  height: 20px;
  margin-right: 1px;
}

.usb-sample {
  width: 100%;
  z-index: 100;
}

.usb-section {
  padding: 16rem 8rem 16rem 8rem;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

#on-the-network {
  flex-direction: column;
  align-items: center;
}

#three-up-section {

  .three-up-inner {
    max-width: 1200px;
  }

  h1 {
    margin-bottom: 16rem;
    font-weight: 800;
  }

  .three-container {
    display: flex;
    gap: 4rem;
    justify-content: center;

    .feature {
      display: block;
    }

    h2 {
      color: #bebebe;
    }
  }
}

.on-the-network-text-section {
  margin-bottom: 10rem;
  max-width: 1200px;
  width: 100%;
}

.on-the-network-img-section {
  display: flex;
  align-items: center;
  position: relative;
  max-width: 1200px;
  margin-bottom: 16rem;
}

.static-console-img {
  width: 70%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 4rem;
}

.carousel {
  width: 70%;
  position: absolute;
  right: 0;
}

#palm {
  padding: 0rem 8rem 16rem 8rem;

  .palm-container {
    display: flex;
    gap: 8rem;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    max-width: 1200px;

    .img-container {
      width: 40%;
      max-width: 40rem;
      aspect-ratio: 1;
      position: relative;

      img {
        width: 100%;
        position: absolute;
      }

      .blur {
        position: absolute;
        filter: blur(20px);
      }
    }

    .keys {
      color: #cdcdcd;
      position: relative;

      img {
        position: absolute;
        width: 100%;
        top: 15px;
      }
    }

  }
}



#best-of-both-worlds {
  background-image: url('/figures/classic_footer.png');
  aspect-ratio: 1;
  max-height: 110vh;
  background-size: cover;
  background-position: center 72%;
  padding-top: 8rem;
  position: relative;

  .text-container {
    max-width: 48rem;
    text-align: center;
    text-shadow: 0px 1px 10px rgba(0,0,0,1);
  }



  .top-gradient {
    top: 0;
    background: linear-gradient(180deg, rgba(28, 28, 28, 1) 0%, rgba(28, 28, 28, 0) 90%);
  }

  .bottom-gradient {
    bottom: 0;
    background: linear-gradient(0deg, rgba(28, 28, 28, 1) 0%, rgba(28, 28, 28, 0) 90%);
  }
}

#join-the-club {
  display: flex;
  position: relative;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: #272727;
  gap: 2rem;
  padding: 12rem 4rem 16rem 4rem;

  h2 {
    margin-right: 8px;
    padding-bottom: 8px;
    font-size: 26px;
  }

  .sample-7-indent {
    max-width: 48rem;
    width: 100%;
  }

  .text-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 9999px;
    padding: 8rem 8rem;
    box-sizing: border-box;
    background-color: #272727;
    max-width: 800px;
    width: 100%;
    box-shadow: inset -3px -5px 9px 0 rgba(255, 255, 255, 0.09), inset 3px 5px 14px 0 rgba(0, 0, 0, 0.35);
  }

  .cta-container {
    display: flex;

    .detail-text {
      width: auto;
    }
  }

  .bottom-gradient {
    bottom: 0;
    background: linear-gradient(0deg, rgba(28, 28, 28, 1) 0%, rgba(28, 28, 28, 0) 90%);
  }
}

.icon.icon-home + .feature-title-padded {
  margin-left: 9px;
}

@media screen and (max-width: 700px) {

  .usb-section {
    padding: 4rem 2.5rem 4rem 2.5rem;
  }

  h1 {
    font-size: 36px;
  }

  h2 {
    font-size: 22px;
  }

  h3 {
    font-size: 16px;
  }

  .icon {
    width: 3rem;
    display: inline-flex;
    justify-content: flex-start;
  }

  .icon.icon-home {
    width: 2.25rem;
  }

  .icon.icon-home + .feature-title-padded {
    margin-left: 3px;
  }

  .diamond-icon {
    position: relative;
    top: 6px;
    transform: scale(0.9);


  }

  .usbc-icon {
    position: relative;
    transform: scale(.8);
    top: 4px;
  }

  .key-icon {
    position: relative;
    transform: scale(.8);
    top: 3px;
  }

  #three-up-section {
    margin-top: 8rem;
    margin-bottom: 8rem;

    h1 {
      margin-bottom: 8rem;
    }

    .three-container {
      flex-direction: column;
    }
  }

  #on-the-network {
    margin-bottom: 8rem;

    .static-console-img {
      width: 90%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      left: 0;
      top: -6rem;
    }

    .on-the-network-img-section {
      align-items: flex-end;
    }

    .on-the-network-text-section {
      margin-bottom: 10rem;
    }
  }

  #palm {
    flex-direction: column;
    padding: 4rem 2.5rem 10rem 2.5rem;

    .palm-container {
      flex-direction: column-reverse;

      .img-container {
        max-width: unset;
        width: 80%
      }
    }
  }

  #best-of-both-worlds {
    aspect-ratio: unset;
    padding-top: 6rem;
    height: 160vw;
    background-image: url('/figures/best-of-both-worlds.png');
    max-height: 100vh;
    background-position: bottom;
  }

  #join-the-club {
    padding: 4rem 2rem 8rem 2rem;

    .sample-7-indent {
      width: 70%;
    }

    .text-container {
      padding-top: 4rem;
      padding-bottom: 4rem;
    }
  }

}
</style>
